import React from 'react';
import LinkList, { LinkListItem } from '@tamagoshi/core/LinkList';
import Spacing from '@tamagoshi/core/Spacing';
import { getFooterContext } from '@context';
import { computeUrl } from '@utils';
import { getTranslations } from '@translations';

import { navigationLinks } from './constants';

const Navigation = () => {
  const { platform, baseUrl } = getFooterContext();
  const translations = getTranslations();

  return (
    <LinkList>
      {navigationLinks[platform].map(({ id, href, dataQa, ...restProps }) => (
        <Spacing key={id} type="py" size={8}>
          <LinkListItem
            {...restProps}
            key={id}
            href={computeUrl(baseUrl, translations(href))}
            data-qa={dataQa}
          >
            {translations(id)}
          </LinkListItem>
        </Spacing>
      ))}
    </LinkList>
  );
};

Navigation.displayName = 'Navigation';

export default Navigation;
